export default{dataTableRow:"w_Gp",selected:"w_Gq"};
